import { render, staticRenderFns } from "./DeleteVideoDialog.vue?vue&type=template&id=1ac4d9d8&"
import script from "./DeleteVideoDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteVideoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports